import React from 'react';

import { Grid, Typography } from 'e100-react-components';
import CopyingTextToClipboard from 'components/CopyingTextToClipboard';

import { useIntl } from 'react-intl';
import { useSelectedCarEBoxLocation } from 'entities/cars';

const ObuNumber = () => {
  const { formatMessage } = useIntl();
  const { obuNumber } = useSelectedCarEBoxLocation() || {};

  return (
    <Grid item xs={12}>
      <Grid container justify="space-between">
        <Grid item xs={6}>
          <Typography variant="caption" gutterBottom>
            {formatMessage({ id: 'OBU' })}:
          </Typography>
        </Grid>
        <Grid item xs={6}>
          <Typography variant="caption">
            <CopyingTextToClipboard>{obuNumber}</CopyingTextToClipboard>
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

export default ObuNumber;
